<!--
  基本的なスタイル指定を含めてTkGlobalModalをラップしたコンポーネント
  (TkGlobalModalは、親コンポーネント側で背景のグレーや、
  デフォルトのヘッダ・閉じるボタンのスタイルを指定する必要がある)
-->
<template>
  <tk-global-modal
    :class="['tkGeneralPurposeModal', theme]"
    :no-show-header="noShowHeader"
    :close-text="closeText"
    :no-sp-fullscreen="noSpFullscreen"
    :inline-close="inlineClose"
    :no-close-on-backdrop="noCloseOnBackdrop"
    :no-close-on-esc="noCloseOnEsc"
    :no-backdrop="noBackdrop"
    @close="$emit('close', $event)"
  >
    <slot />
  </tk-global-modal>
</template>

<script>
import TkGlobalModal from '../../atoms/TkGlobalModal/TkGlobalModal'

export default {
  name: 'TkGeneralPurposeModal',
  components: {
    TkGlobalModal,
  },
  props: {
    noShowHeader: {
      type: Boolean,
      default: false,
    },
    closeText: {
      type: String,
      default: '',
    },
    noSpFullscreen: {
      type: Boolean,
      default: false,
    },
    inlineClose: {
      type: Boolean,
      default: false,
    },
    noCloseOnBackdrop: {
      type: Boolean,
      default: false,
    },
    noCloseOnEsc: {
      type: Boolean,
      default: false,
    },
    noBackdrop: {
      type: Boolean,
      default: false,
    },
    theme: {
      type: String,
      default: 'default',
    },
  },
}
</script>

<style scoped lang="scss">
.tkGeneralPurposeModal {
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  padding-right: 0 !important; /* TkGlobalModalコンポーネントのスタイル打消し用 */
  inset: 0;
  z-index: 1040;
  outline: 0;
}
</style>

<style lang="scss">
.tkGeneralPurposeModal {
  .modal-content {
    position: relative;
    background-color: #fff;
  }

  &.default {
    .tourHotelPlaceModal_topbar {
      width: auto;
      height: auto;
      /* ↓TkGlobalModalコンポーネントのimportantスタイル上書きのためimportantを使用 */
      display: block !important;
    }
    .btn.btn-link.tourHotelPlaceModal_close {
      text-align: left;
      font-weight: 700;
      color: #fff;
      background-color: #63666a;
      width: 100%;
      padding: 8px 12px;
      position: relative;
      display: inline-flex;
      vertical-align: middle;
      touch-action: manipulation;
      cursor: pointer;
      border: 1px solid rgba(0, 0, 0, 0);
      white-space: nowrap;
      font-size: 14px;
      line-height: 1.42857143;
      -webkit-user-select: none;
      user-select: none;
      align-items: center;
      text-decoration: none;
    }
  }
}
</style>
